import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { aditionalServiceDialogStyles as styles } from '../staff/styles';

function AdditionalCourseDialog({ onConfirm, onCancel, open, classes, title = 'Do you want to add another course?' }) {
    return (
        <>
            <Dialog open={!!open}>
                <DialogContent>
                    <DialogContentText className={classes.text}>{title}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className={classes.button} onClick={onConfirm}>
                        Yes
                    </Button>
                    <Button className={classes.button} onClick={onCancel}>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

AdditionalCourseDialog.propTypes = {
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    title: PropTypes.string
};

export default withStyles(styles)(AdditionalCourseDialog);
